module.exports = __webpack_public_path__ + "01.png?baa6ee9d4392aa98a8002b6c7fd5f5ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/01.png
// module id = 114
// module chunks = 0